



/**
* @description  j接口异常调用的接口
* @param {String} name
* @returns void or Promise
*/
  // 接口异常调用的接口白名单
const whiteUrl =  ['/api/service-system-app/app/api-error-result/send']
export const unusualInteface = (axios,response)=>{
  let erroeMes = {
    code:response.data.code,
    message:response.data.message,
    platform:response.config.headers.pkManagerCorp=='platform'?1:2, //1平台 2商户
    traceId:response.data.traceId,
    url:response.config.url,
  }
  if(whiteUrl.includes(erroeMes.url))return;
  if(response.data.code==1){ //部分老接口状态码是有问题的,给测试看
    console.log('状态码异常接口找后端',erroeMes)
  }
  axios({
    method:'post',
    url: "/service-system-app/app/api-error-result/send",
    data:erroeMes,
    timeout:500
  }).then(res => {})
}
